module.exports = __webpack_public_path__ + "fonts/bold.1fd3b6ce.woff";